import React, {Component} from 'react';
import axios from 'axios';
import uuidv4 from "uuid/v4";
import ReactJson from 'react-json-view';
import {Button, Dimmer, Dropdown, Form, Grid, Icon, Label, Loader, Message, Segment, Tab} from "semantic-ui-react";
import {DatesRangeInput} from 'semantic-ui-calendar-react';

export default class Transactions extends Component {

    state = {
        data: {},
        accts: [],
        acct: "",
        loading: false,
        txnLoading: false,
        paymentsLoading: false,
        customerLoading: false,
        error: false,
        dpErr: false,
        errMsg: "There was an issue while retrieving the data.",
        fiErr: false,
        linked: [],
        fiLoading: true,
        fi: "",
        time: "rt",
        version: "v1",
        ddaId: "",
        dates: "",
        start: "",
        end: "",
        checked: false,
        showFilter: false,
        resultType: 'details',
        showResultType: false
    };

    checkSession = () => {
        axios.get("/session").then(res => {
            console.log(res.status);
            console.log(res.data);
            if (res.status === 200 && !res.data) {
                console.log("session expired...");
                window.location.reload(true);
            }
        }).catch(err => {
            console.log("error getting session details --- " + err);
            window.location.reload(true);
        });
    };

    handleChange = (e, { name, value }) => {
        this.setState({acct: value});
    };

    handleFIAccountChange = (e, { name, value }) => {
        this.setState({fi: value});
        setTimeout(() => {
            if (name === "txnFI") {
                this.getAccountList();
            }
        }, 500);
    };

    handleRadioChange = (e, { value }) => this.setState({ time: value });
    handleVersionChange = (e, { value }) => this.setState({ version: value });
    handleResultTypeChange = (e, { value }) => this.setState({ resultType: value });
    handleFilterChange = () => this.setState((prevState) => ({checked: ! prevState.checked}));

    handleTabChange = (e, data) => {
        this.checkSession();
        this.setState({
            data: {},
            error: false,
            accts: [],
            linked: [],
            fi: "",
            acct: "",
            time: "rt",
            ddaId: "",
            dates: "",
            start: "",
            end: "",
        });
        this.getLinkedAccounts();
    };

    handleSubmit = (e, {id}) => {
        let reqId = uuidv4();
        switch (id) {
            case "accounts":
                this.setState({
                    data: {},
                    txnLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getAccountsDetails(reqId);
                break;
            case "txns":
                this.setState({
                    data: {},
                    txnLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getTxns(reqId);
                break;
            case "payments":
                this.setState({
                    data: {},
                    paymentsLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getPayments(reqId);
                break;
            case "customer":
                this.setState({
                    data: {},
                    customerLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getCustomer(reqId);
                break;
        }
    };

    getAccountList = () => {
        this.setState({loading: true, dpErr: false});
        axios.get('/api/accountlist/' + this.props.env, {
            params: {
                fi: this.state.fi
            }
        }).then(res => {
            if (res.status === 200 && res.data) {
                let accts = [];
                let cnt = 0;
                res.data.forEach(a => {
                    accts.push({
                        key: cnt,
                        value: a,
                        text: a
                    });
                });
                this.setState({accts: accts, loading: false});
            } else {
                this.setState({dpErr: true, loading: false});
            }
        }).catch(err => {
            console.log(err);
            this.setState({dpErr: true, loading: false});
        });
    };

    getTxns = (id) => {
        axios.get("/api/transactions/" + this.props.env, {
            params: {
                account: this.state.acct,
                fi: this.state.fi,
                ddaId: id,
                start: this.state.start,
                end: this.state.end,
                offset: "0",
                limit: "50",
                version:""
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, txnLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, txnLoading: false});
                }
            } else {
                this.setState({data: res.data, txnLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, txnLoading: false});
            console.log(err);
        });
    };

    getPayments = (id) => {
        axios.get("/api/payments/" + this.props.env, {
            params: {
                account: this.state.acct,
                fi: this.state.fi,
                ddaId: id
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, paymentsLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, paymentsLoading: false});
                }
            } else {
                this.setState({data: res.data, paymentsLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, paymentsLoading: false});
            console.log(err);
        });
    }

    getCustomer = (id) => {
        axios.get("/api/customer/" + this.props.env, {
            params: {
                fi: this.state.fi,
                ddaId: id
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, customerLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, customerLoading: false});
                }
            } else {
                this.setState({data: res.data, customerLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, customerLoading: false});
            console.log(err);
        });
    }

    getAccountsDetails = (id) => {
        axios.get("/api/fi/accountdetails/" + this.props.env, {
            params: {
                fi: this.state.fi,
                resultType: this.state.resultType,
                ddaId: id
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, txnLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, txnLoading: false});
                }
            } else {
                this.setState({data: res.data, txnLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, txnLoading: false});
            console.log(err);
        });
    };

    getLinkedAccounts = () => {
        axios.get("/api/fi/accounts", {
            params: {
                fi: this.state.fi
            }
        }).then(res => {
            if (res.status === 200 && res.data) {
                this.setState({fiLoading: false, linked: res.data});
            } else {
                this.setState({fiLoading: false, fiErr: true});
            }
        }).catch(err => {
            console.log(err);
            this.setState({fiLoading: false, fiErr: true});
        })
    };

    onDateChange = (e, {name, value}) => {
        console.log(name);
        console.log(value);
        if (value === '') {
            this.setState({start: "", end: ""});
        }
        this.splitDates(value);
        if (this.state.hasOwnProperty(name)) {
            this.setState({ [name]: value });
        }
    };

    splitDates = (dates) => {
        let split = dates.split(" - ");
        if (split.length === 2) {
            this.setState({start: split[0], end: split[1]});
        }
    };

    componentDidMount() {
        this.props.compUpdate();
        this.getLinkedAccounts();
    }

    render() {

        const {
            data,
            accts,
            loading,
            txnLoading,
            error,
            dpErr,
            errMsg,
            fiErr,
            fiLoading,
            linked,
            fi,
            time,
            version,
            ddaId,
            dates,
            start,
            end,
            checked,
            showFilter,
            resultType,
            paymentsLoading,
            customerLoading
        } = this.state;

        const panes = [
            {
                menuItem: "Accounts Details",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={6}>
                                    <ResultTypeSelection resultType={resultType} change={this.handleResultTypeChange} />
                                </Grid.Column>
                                <Grid.Column width={6}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="details-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              name="detailsFI" />
                                </Grid.Column>
                                <Grid.Column width={4}>
                                    <Button id="accounts" onClick={this.handleSubmit} disabled={!fi}>Submit</Button>
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={txnLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "Transactions",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              name="txnFI" />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={dpErr ? 'Could not get accounts' : 'Select an account'}
                                              fluid search selection
                                              options={accts}
                                              onChange={this.handleChange}
                                              data-it="accounts-dropdown"
                                              native={true}
                                              loading={loading}
                                              error={dpErr}
                                              disabled={dpErr || !fi} />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <DatePicker onDateChange={this.onDateChange} dates={dates} disabled={false} />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="txns"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={accts.length === 0} />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={txnLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "Payments",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              name="txnFI" />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={dpErr ? 'Could not get accounts' : 'Select an account'}
                                              fluid search selection
                                              options={accts}
                                              onChange={this.handleChange}
                                              data-it="accounts-dropdown"
                                              native={true}
                                              loading={loading}
                                              error={dpErr}
                                              disabled={dpErr || !fi} />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="payments"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={accts.length === 0} />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={paymentsLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "Customer",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              name="txnFI" />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="customer"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={!fi} />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={customerLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            }
        ];

        return (
            <Tab grid={{ paneWidth: 16, tabWidth: 4 }} panes={panes} onTabChange={this.handleTabChange} />
        )

    }

}

const JSONSegment = ({error, errMsg, data, txnLoading}) => (
    <Segment.Group className={'txn-pane'}>
        <Dimmer inverted active={txnLoading}>
            <Loader inverted size='medium' content='Loading' />
        </Dimmer>
        {error ?
            (<Segment>
                <Message error>
                    <p>{errMsg}</p>
                    <p>Please try refreshing or check back later.</p>
                </Message>
            </Segment>) :
            <Segment>
                <ReactJson
                    src={data}
                    name={false}/>
            </Segment>
        }
    </Segment.Group>
);

const RadioSelection = ({time, change}) => (
    <Form>
        <Form.Group inline>
            <label>Time selection</label>
            <Form.Radio
                label='Real Time'
                name='radioGroup'
                value='rt'
                checked={time === 'rt'}
                onChange={change}
            />
            <Form.Radio
                label='T-1'
                name='radioGroup'
                value='t1'
                checked={time === 't1'}
                onChange={change}
            />
        </Form.Group>
    </Form>
);

const VersionSelection = ({version, change}) => (
    <Form>
        <Form.Group inline>
            <label>Version selection</label>
            <Form.Radio
                label='Version 1'
                name='radioGroup'
                value='v1'
                checked={version === 'v1'}
                onChange={change}
            />
            <Form.Radio
                label='Version 4'
                name='radioGroup'
                value='v4'
                checked={version === 'v4'}
                onChange={change}
            />
        </Form.Group>
    </Form>
);

const ResultTypeSelection = ({resultType, change}) => (
    <Form>
        <Form.Group inline>
            <label>V4 ResultType selection</label>
            <Form.Radio
                label='Lightweight'
                name='radioGroup'
                value='lightweight'
                checked={resultType === 'lightweight'}
                onChange={change}
            />
            <Form.Radio
                label='Details'
                name='radioGroup'
                value='details'
                checked={resultType === 'details'}
                onChange={change}
            />
        </Form.Group>
    </Form>
);

const FilterSelection = ({checked, change}) => (
    <Form>
        <Form.Group inline>
            <Form.Checkbox
                label='No Filter'
                checked={checked}
                onChange={change}
            />
        </Form.Group>
    </Form>
);

const RequestDetailLabel = ({title, text}) => (
    <Label>
        {title}
        <Label.Detail>{text}</Label.Detail>
    </Label>
);

const DatePicker = ({ onDateChange, dates, disabled }) => (
    <DatesRangeInput
        name="dates"
        placeholder="Start - End"
        value={dates}
        iconPosition="left"
        onChange={onDateChange}
        clearable={true}
        disabled={disabled}
        clearIcon={<Icon name="remove" color="red" />}
        hideMobileKeyboard={true}
        popupPosition={"bottom left"}
        dateFormat={"YYYY-MM-DD"}
        allowSameEndDate={false}
    />
);
